export default "__VITE_ASSET__VAzKxh6L__"